export var processUnicodeInElement = function (el, caretOffset, removeUnicodeFn) {
    var originalTextForCheck = el.textContent || '';
    var textBeforeCaret = originalTextForCheck.slice(0, caretOffset);
    var processedTextBeforeCaret = removeUnicodeFn(textBeforeCaret);
    var removedCharsCount = textBeforeCaret.length - processedTextBeforeCaret.length;
    // More complicated way, since we process the elements individually,
    // so we can maintain proper cursor position, new lines & it's more optimized way
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node = null;
    var modified = false;
    node = walker.nextNode();
    while (node !== null) {
        var original = node.textContent || '';
        var stripped = removeUnicodeFn(original);
        if (original !== stripped) {
            node.textContent = stripped;
            modified = true;
        }
        node = walker.nextNode();
    }
    return {
        modified: modified,
        newContent: modified ? el.textContent || '' : originalTextForCheck,
        adjustedCaretOffset: modified ? caretOffset - removedCharsCount : caretOffset,
    };
};
